import React from 'react';
import { AiOutlineAppstore } from "react-icons/ai";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { GiTakeMyMoney } from "react-icons/gi";
import { IoIosDesktop } from "react-icons/io";
import { HiOutlineBuildingStorefront } from "react-icons/hi2";

export type IconName = 
    | 'AiOutlineAppstore'
    | 'MdOutlineAccountBalanceWallet'
    | 'GiTakeMyMoney'
    | 'IoIosDesktop'
    | 'HiOutlineBuildingStorefront';

export const ImportMenuIcon: React.FC<{ icon: IconName }> = ({ icon }) => {
    switch (icon) {
        case 'AiOutlineAppstore':
            return <AiOutlineAppstore />;
        case 'MdOutlineAccountBalanceWallet':
            return <MdOutlineAccountBalanceWallet />;
        case 'GiTakeMyMoney':
            return <GiTakeMyMoney />;
        case 'IoIosDesktop':
            return <IoIosDesktop />;
        case 'HiOutlineBuildingStorefront':
            return <HiOutlineBuildingStorefront />;
        default:
            return null;
    }
};
